import { SVGProps } from "react";

const InventoryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0019 22.2498C11.1819 22.2498 10.3619 21.9898 9.68185 21.4798L4.47186 17.5798C3.50186 16.8498 2.92188 15.6898 2.92188 14.4798V1.75977H21.0818V14.4798C21.0818 15.6898 20.5019 16.8498 19.5319 17.5798L14.3219 21.4798C13.6419 21.9898 12.8219 22.2498 12.0019 22.2498ZM4.42188 3.24977V14.4698C4.42188 15.2098 4.78186 15.9198 5.37186 16.3698L10.5818 20.2698C11.4218 20.8998 12.5919 20.8998 13.4319 20.2698L18.6419 16.3698C19.2319 15.9198 19.5919 15.2098 19.5919 14.4698V3.24977H4.42188Z"
      fill={props.fill || "white"}
    />
    <path
      d="M22 3.25H2C1.59 3.25 1.25 2.91 1.25 2.5C1.25 2.09 1.59 1.75 2 1.75H22C22.41 1.75 22.75 2.09 22.75 2.5C22.75 2.91 22.41 3.25 22 3.25Z"
      fill={props.fill || "white"}
    />
    <path
      d="M16 8.75H8C7.59 8.75 7.25 8.41 7.25 8C7.25 7.59 7.59 7.25 8 7.25H16C16.41 7.25 16.75 7.59 16.75 8C16.75 8.41 16.41 8.75 16 8.75Z"
      fill={props.fill || "white"}
    />
    <path
      d="M16 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H16C16.41 12.25 16.75 12.59 16.75 13C16.75 13.41 16.41 13.75 16 13.75Z"
      fill={props.fill || "white"}
    />
  </svg>
);

export default InventoryIcon;
